import {FC, ReactNode} from "react";
import {DialogTitle} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {CloseOutlined} from "@mui/icons-material";

export interface Props {
    children?: ReactNode;
    onClose: () => void;
}

const CustomDialogTitle: FC<Props> = (props) => {
    const {children, onClose, ...other} = props;

    return (
        <DialogTitle sx={{
            m: 0,
            pt: {xs: 1.25, sm: 1.5},
            pb: {xs: 1.5, sm: 2.5},
            pl: {xs: 2, sm: 3},
            pr: {xs: 5.5, sm: 6},
            fontWeight: 600
        }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseOutlined/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

export default CustomDialogTitle
